import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card,Tabs,Tab } from 'react-bootstrap';
import './ProjectViewPage.css';
import ManageFieldsModal from 'modules/project-view/ManageFieldsModal/ManageFieldsModal';
import FieldsAddImagesModal from 'modules/project-view/FieldsAddImagesModal';
import ProjectHeader from 'modules/project-view/ProjectHeader';
import ProjectFieldsSection from 'modules/project-view/ProjectFieldsSection';
import ExtractionInstructions from 'modules/project-view/ExtractionInstructions';
import FieldsSideMenu from 'modules/project-view/FieldsSideMenu';
import { useGetProjectQuery } from 'pages/project-view-page/queries/useGetProjectQuery';
import { Loader } from 'components/common/Loader';
import FilesTable from 'modules/FilesTable/FilesTable';

const ProjectPage = () => {
  const { id } = useParams();
  const [isManageFieldsFormVisible, setManageFieldsFormVisible] = useState(false);
  const [isAddFilesModalVisible, setAddFilesModalVisible] = useState(false);
  const [field, setField] = useState(null);
  const [sortedFields, setSortedFields] = useState([]);
  const { data: project, isLoading: isProjectLoading, isError: hasProjectError } = useGetProjectQuery(id);

  const showManageFieldsModal = useCallback(() => {
    setManageFieldsFormVisible(true);
  }, [setManageFieldsFormVisible]);

  if (isProjectLoading) {
    return <Loader />;
  }
  if (hasProjectError) {
    return <h1>Can't load the project</h1>;
  }

  return (
    <>
      <Card className="bg-light">
        <ProjectHeader project={project} id={id} />
        <Card.Body>
          <div className="mb-5 project-page-card-wrapper">
            <div className="project-page-rules-list">

              <FieldsSideMenu setShowFilesModal={setAddFilesModalVisible} />

              <Tabs defaultActiveKey="Files" id="uncontrolled-tab-example">
                <Tab eventKey="Files" title="Files" className='border-bottom border-x p-3'>
                  <FilesTable sortedFields={sortedFields} />
                </Tab>
                <Tab eventKey="Fields" title="Fields" className='border-bottom border-x p-3'>
                  <ProjectFieldsSection showManageFieldsModal={showManageFieldsModal} setField={setField} setSortedFields={setSortedFields} />
                </Tab>
                <Tab eventKey="Settings" title="Settings" className='border-bottom border-x p-3'>
                  <ExtractionInstructions project={project} id={id} isProjectLoading={isProjectLoading} />
                </Tab>
              </Tabs>
            </div>
          </div>
          
        </Card.Body>
      </Card>

      {isManageFieldsFormVisible && (
        <ManageFieldsModal
          closeModal={() => {
            setField(null);
            setManageFieldsFormVisible(false);
          }}
          fieldId={field}
          isFileView={false}
        />
      )}

      <FieldsAddImagesModal closeModal={() => setAddFilesModalVisible(false)} isVisible={isAddFilesModalVisible} />
    </>
  );
};

export default ProjectPage;
